<template>
  <v-container fluid class="down-top-padding">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-row cols="12" lg="12" sm="1">
      <v-col cols="12" lg="12" sm="1">
        <v-card color="info">
            <v-card-actions class="pa-6">
              <v-row class="" cols="12" lg="12" sm="1">
                <v-col class="" cols="12" lg="2" sm="1" style="background-color: #1e88e5;padding: 0px;" align="center"
                  justify="center">
                  <img src="../assets/images/logo-png.png" class="" height="75px"/>
                </v-col>
                <v-col cols="12" lg="8" sm="1" height="40px" style="background-color: #1e88e5;" align="center"
                  justify="center" class="white--text">
                  <h1>CUADRO DE MANDO INTEGRAL</h1>
                </v-col>
                <v-col cols="12" lg="2" sm="1" height="40px" style="background-color: #1e88e5;" align="right" class="white--text">
                  <h6>Actualizado al {{ ultimaFecha }}</h6>
                </v-col>
              </v-row>
            </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-1">
      <v-col cols="12" md="12" sm="1">
        <v-carousel
        show-arrows-on-hover
        hide-delimiters
        height="140"
        v-if="renderComponent4 && !isMobile()"
        >
          <v-carousel-item
            v-for="i in nroSlides2"
            :key="i"
          >
            <v-sheet
            color="#FFFFFF"
            tile
            >
              <v-row
                class="fill-height"
                align="center"
                justify="center"
                cols="12" lg="12" sm="1"
              > <v-col
                    v-for="(alerta, j) in alertas"
                    :key="j"
                    cols="12" sm="1" lg="3" md="3" v-show="j >= (i-1)*4 && j<= (i-1)*4+3" style="padding:0px; text-align:center" padding="20px">
                    <Alerta :ID_ALERTA="alerta.ID_ALERTA" :NOMBRE_ALERTA="alerta.NOMBRE_ALERTA" :anio="anio" :VALOR_ACTUAL="alerta.valor_actual" :VALOR_ANTERIOR="alerta.valor_anterior" :mes="mes" :red="red" :microred="microred" :establecimiento="establecimiento" :tituloCurso="cursoVida" :tituloGrupo="grupoEtareo" :tituloAvance="tituloAvanceGraficos"></Alerta>
                </v-col>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
        <v-carousel
        show-arrows-on-hover
        hide-delimiters
        height="170"
        v-else
        >
          <v-carousel-item
            v-for="(alerta, i) in alertas"
            :key="i"
          >
            <v-sheet
            color="#FFFFFF"
            tile
            >
              <v-row
                class="fill-height"
                align="center"
                justify="center"
              > 
              <Alerta :ID_ALERTA="alerta.ID_ALERTA" :NOMBRE_ALERTA="alerta.NOMBRE_ALERTA" :VALOR_ACTUAL="alerta.valor_actual" :VALOR_ANTERIOR="alerta.valor_anterior" :mes="mes" :red="red" :microred="microred" :establecimiento="establecimiento" :tituloCurso="cursoVida" :tituloGrupo="grupoEtareo" :tituloAvance="tituloAvanceGraficos"></Alerta>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-col>
      <v-col cols="12" md="12" sm="1">
        <v-card>
          <v-card-text class="border-bottom">
            <v-btn block color="primary" @click="abrirAlerta">
              VER TODAS LAS ALERTAS
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-card-text class="pa-5 border-bottom">
            <form>
              <v-row>
                <v-col cols="12" sm="1" lg="2" style="padding: 0px 12px;">
                  <v-autocomplete :items="redes" label="Red" v-model="red"  @change="updateRed" placeholder="Todas las redes" item-text="Nombre" item-value="Id" multiple dense  outlined clearable required chips small-chips></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="1" lg="2" style="padding: 0px 12px;">
                  <v-autocomplete :items="microredes" label="MicroRed" v-model="microred" placeholder="Todas las microredes" @change="updateMicroRed" item-text="Nombre" item-value="Id" multiple dense  outlined clearable required chips small-chips></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="1" lg="2" style="padding: 0px 12px;">
                  <v-autocomplete :items="establecimientos" label="Establecimiento" placeholder="Todos los establecimientos" @change="updateEstablecimiento" v-model="establecimiento"  item-text="Nombre" item-value="Id" multiple dense  outlined clearable required chips small-chips></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="1" lg="2" style="padding: 0px 12px;">
                  <v-autocomplete :items="anios" placeholder="Año" label="Año" @change="updateAnio"  v-model="anio"  dense outlined chips small-chips></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="2" lg="2" style="padding: 0px 12px;">
                  <v-autocomplete :items="meses" label="Mes" v-model="mes" placeholder="Todos los meses" @change="updateMeses" item-text="Nombre" item-value="Id" dense multiple outlined required chips small-chips>
                    <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                        <span>{{ item.Nombre }}</span>
                        </v-chip>
                        <span
                        v-if="index === 1"
                        class="grey--text caption"
                        >(+{{ mes.length - 1 }} Meses)</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="14" sm="2" lg="2" style="padding: 0px 12px;">
                  <v-autocomplete :items="cursosVidas" v-model="cursoVida" placeholder="Todos" label="Cursos de Vida" @change="updateCursoVida" item-text="name" item-value="id" dense  outlined required chips small-chips></v-autocomplete>
                </v-col>
                <v-col v-if="cursoVida == 2" cols="12" sm="2" lg="2" style="padding: 0px 12px;">
                  <v-autocomplete :items="gruposEtareos" v-model="grupoEtareo" label="Grupo Etareo" item-text="name" item-value="id" @change="updateSubCursoVida" dense  outlined required chips small-chips></v-autocomplete>
                </v-col>
              </v-row>
            </form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        <v-carousel
        show-arrows-on-hover
        height="250"
        hide-delimiters
        v-if="renderComponent"
        >
          <v-carousel-item
            v-for="i in nroSlides"
            :key="i"
          >
            <v-sheet
            color="#FFFFFF"
            height="100%"
            tile
            >
              <v-row
                class="fill-height"
                align="center"
                justify="center"
                
              > <v-col
                    v-for="(item, j) in indicadores"
                    :key="j"
                    cols="12" md="3" v-show="j >= (i-1)*4 && j<= (i-1)*4+3" style="padding:0px; text-align:center"
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn color="#FFFFFF"
                          depressed
                          v-bind="attrs"
                          v-on="on"
                        >
                          <h5><b style="color:black;">{{ item.RESUMEN }}</b></h5>
                          <h5><b v-if="item.NOMBRE_ACTIVIDAD.length > 30" style="color:black;">...</b></h5>
                        </v-btn>
                      </template>
                      <span>{{ item.NOMBRE_ACTIVIDAD }}</span>
                    </v-tooltip>
                    <Radial :id="item.ID_ACTIVIDAD" :numerador="item.NUMERADOR" :denominador="item.DENOMINADOR"></Radial>
                </v-col>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12"><br> </v-col>
      <v-col cols="12" md="7">
        <v-card v-if="renderComponent2">
          <v-card-text>
            <span>
              <SpiderwebCharts height="800" :serie="cursoVida" :datos="indicadoresR.avance" :grupo="grupoEtareo" :categorias="indicadoresR.series" :tituloAvance="tituloAvanceGraficos">
              </SpiderwebCharts>
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="5">
        <v-row>
          <v-col cols="12" md="12">
            <v-card>
            <center><b>MORBILIDADES</b> </center>
            <TablaMorbilidad :morbilidades="morbilidades"></TablaMorbilidad>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <v-card>
              <center><b>MEDICAMENTOS, INSUMOS Y DROGAS</b> </center>
              <TablaMedicamentos :medicamentos="medicamentos"></TablaMedicamentos>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogAlerta" >
      <v-col cols="12" lg="12">
        <v-card>
          <v-card-title class="primary white--text" style="text-align:center">
          <span class="text-h5">ALERTAS</span></v-card-title>
          <v-spacer></v-spacer>
          <v-card-text>
            <v-row
            class="fill-height white--text"
            align="center"
            justify="center"
            cols="12" lg="12" sm="1"
          > 
            <v-col
                v-for="(alerta, j) in alertas"
                :key="j"
                cols="12" sm="1" lg="3" md="3" style="padding:0px; text-align:center" padding="20px"
                >
                <Alerta :ID_ALERTA="alerta.ID_ALERTA" :NOMBRE_ALERTA="alerta.NOMBRE_ALERTA" :VALOR_ACTUAL="alerta.valor_actual" :VALOR_ANTERIOR="alerta.valor_anterior" :mes="mes" :red="red" :microred="microred" :establecimiento="establecimiento" :tituloCurso="cursoVida" :tituloGrupo="grupoEtareo" :tituloAvance="tituloAvanceGraficos"></Alerta>
            </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
  </v-dialog>
  </v-container>
</template>

<script>

import CursosVidasResource from '@/apis/cursoVida';
const cursosVidasResource = new CursosVidasResource()
import CargasResource from '@/apis/cargas';
const cargasResource = new CargasResource()


import axios from 'axios';

export default {
  name: "CMI",
  data: () => ({
    page: {
      title: "StarterPage"
    },
    dialogAlerta: false,
    renderComponent: true,
    renderComponent2: true,
    renderComponent3: true,
    renderComponent4: true,
    overlay: false,
    redes: [],
    red: [],
    microredes: [],
    microred: [],
    establecimientos: [],
    establecimiento: [],
    establecimiento2: [],
    cursosVidas: [],
    cursoVida: 1,
    indicadoresR: [],
    radiales: [],
    radial: '',
    indicadores: [],
    indicador: '',
    grupoEtareo: 0,
    gruposEtareos: [],
    morbilidades: [],
    elementVisible: false,
    nroSlides: 1,
    nroSlides2: 1,
    ultimaFecha: '',
    fechaActual: new Date(),
    mesActual: 1,
    mesActual1: 1,
    mes: [],
    datosIndicadorGrafico: [],
    medicamentos: [],
    tituloAvanceGraficos: '',
    tipoBusqueda: 1,
    meses: [],
    mesesTemp2: [
      {
        Id: 1,
        Nombre: 'Enero'
      },
      {
        Id: 2,
        Nombre: 'Febrero'
      },
      {
        Id: 3,
        Nombre: 'Marzo'
      },
      {
        Id: 4,
        Nombre: 'Abril'
      },
      {
        Id: 5,
        Nombre: 'Mayo'
      },
      {
        Id: 6,
        Nombre: 'Junio'
      },
      {
        Id: 7,
        Nombre: 'Julio'
      },
      {
        Id: 8,
        Nombre: 'Agosto'
      },
      {
        Id: 9,
        Nombre: 'Septiembre'
      },
      {
        Id: 10,
        Nombre: 'Octubre'
      },
      {
        Id: 11,
        Nombre: 'Noviembre'
      },
      {
        Id: 12,
        Nombre: 'Diciembre'
      }
    ],
    anios: null,
    anio: null,
    alertas: [
    ],
    colors: [          
          'warning',
          'light-blue',
          'success',
          'info',
          'error',
          'deep-purple accent-4',
        ],
        slides: [
          'First',
          'Second',
          'Third',
          'Fourth',
          'Fifth',
        ],
    breadcrumbs: [
      {
        text: "StarterPage",
        disabled: true
      }
    ],
    desserts: [
      {
        mid: "VACUNA CONTRA..",
        stock: 376,
        prom: 1027,
        disp:273
      },
      {
        mid: "VACUNA ANTITUBERCULOSA ..",
        stock: 376,
        prom: 1027,
        disp:273
      },
    ]
  }),
  components:{
      Radial: () =>
        import(
          "@/views/dashboards/Graficos/Radiales/Radial"
      ),
      TablaMorbilidad: () => import("./dashboards/Tablas/TablaMorbilidades"),
      TablaMedicamentos: () => import("./dashboards/Tablas/TablaMedicamentos"),
      SpiderwebCharts: () => import('./dashboards/Graficos/Radares/SpiderwebChart'),
      Alerta: () => import("./alertas/Alerta")
  },
  mounted() {
    this.cargarCurso()
  },
  created() {
    this.overlay = true
    this.cargarCurso()
    this.getRedes()
    this.getMicroRedes()
    this.getEstablecimientos()
    this.getCursosVida()
    this.getAnios()
    this.getIndicador()
    this.getRadar()
    this.getAlertas()
    this.getMorbilidades()
    this.getGrupoEtareo()
    this.overlay = false
    this.getMedicamentos()
    this.getUltimaFecha()
  },
  methods: {
    cargarCurso(){
      if(this.$store.state.curso != undefined){
        if(this.$store.state.curso != 1){
          this.cursoVida = this.$store.state.curso
        }
        if(this.$store.state.grupo != 0){
          this.grupoEtareo = this.$store.state.grupo
        }
      }
      this.tipoBusqueda = 1
    },
    async getAnios(){
      await cargasResource.fetchAnios().then(response => {
          this.anios = response
      })
      this.getAnio()
    },
    async getAnio(){
      await cargasResource.fetchAnioMax().then(response => {
          const anio = response
          this.anio = anio.toString()
      })
      this.getMeses()
    },
    async getMes(){
      await cargasResource.fetchMesMax(this.anio).then(response => {
          let mes = response
          this.mesActual = mes;
          this.mesActual1 = mes-1;
      })
    },
    async getMeses(){
      await cargasResource.fetchMeses(this.anio).then(response => {
          let meses = response
          this.meses = []
          for (var i = 0; i < meses.length; i++) {
            let cant = parseInt(meses[i])
            this.meses.push(this.mesesTemp2.find(x => x.Id === cant));
          }
      })
    },
    async getRedes(){
      await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/filtros/redes').then(response => {
          this.redes = response.data
      })
    },
    async getUltimaFecha(){
      await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/cargas/ultimaFecha').then(response => {
          this.ultimaFecha = response.data
      })
    },
    async getMicroRedes(){
      await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/filtros/microredes',{
          params: {
              red: this.red,
          }
      }).then(response => {
          this.microredes = response.data
      })
    },
    async getEstablecimientos(){
      await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/filtros/establecimientos',{
          params: {
              red: this.red,
              microred: this.microred,
              tipoBusqueda: this.tipoBusqueda
          }
      }).then(response => {
          this.establecimientos = response.data
      })
    },
    async getCursosVida(){
      await cursosVidasResource.fetchCursosVidas().then(response => {
            this.cursosVidas = response
      })
    },
    async getIndicador(){
      this.overlay = true
      await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/indicadoresCMI', {
          params: {
              anio: this.anio,
              mes: this.mes,
              red: this.red,
              microred: this.microred,
              establecimiento: this.establecimiento,
              curso: this.cursoVida,
              grupo: this.grupoEtareo
          }
      }).then(response => {
            this.indicadores = response.data
            const nro = Math.ceil(this.indicadores.length/4)
            this.nroSlides = nro
            this.forceRerender()
      })
      this.overlay = false
    },
    forceRerender() {
        // Remove my-component from the DOM
        this.renderComponent = false;

        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent = true;
        });
    },
    forceRerender2() {
        // Remove my-component from the DOM
        this.renderComponent2 = false;

        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent2 = true;
        });
    },
    forceRerender3() {
        // Remove my-component from the DOM
        this.renderComponent3 = false;

        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent3 = true;
        });
    },
    forceRerender4() {
        // Remove my-component from the DOM
        this.renderComponent4 = false;

        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent4 = true;
        });
    },
    async getRadar(){
      this.overlay = true
      await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/indicadoresRadar', {
          params: {
            anio: this.anio,
              mes: this.mes,
              red: this.red,
              microred: this.microred,
              establecimiento: this.establecimiento,
              curso: this.cursoVida,
              grupo: this.grupoEtareo
          }
      }).then(response => {
            this.indicadoresR = response.data
            this.forceRerender2()
      })
      this.overlay = false
    },
    async getMorbilidades(){
      this.overlay = true
      await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/morbilidades/'+this.cursoVida+'/'+this.mesActual, {
          params: {
              anio: this.anio,
              mes: this.mes,
              red: this.red,
              microred: this.microred,
              establecimiento: this.establecimiento,
              curso: this.cursoVida,
              grupo: this.grupoEtareo
          }
      }).then(response => {
            this.morbilidades = response.data
      })
      this.overlay = false
    },
    async getAlertas(){
      this.overlay = true
      await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/alertas/'+this.cursoVida, {
          params: {
              anio: this.anio,
              mes: this.mes,
              red: this.red,
              microred: this.microred,
              establecimiento: this.establecimiento,
              curso: this.cursoVida,
              grupo: this.grupoEtareo
          }
      }).then(response => {
            this.alertas = response.data
            const nro1 = Math.ceil(this.alertas.length/4)
            this.nroSlides2 = nro1
            this.forceRerender4()
      })
      this.overlay = false
    },
    async getGrupoEtareo(){
      await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/subcursosVidas')
      .then(response => {
            this.gruposEtareos = response.data
        })
    },
    async getGraficoIndicador(){
      this.overlay = true
        await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/indicadoresGrafico/'+this.cursoVida,{
            params: {
                anio: this.anio,
                mes: this.mes,
            }
        }).then(response => {
            this.datosIndicadorGrafico = response.data
            this.forceRerender3
        })
        this.overlay = false
    },
    async getMedicamentos(){
      this.overlay = true
      await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/medicamentos', {
          params: {
              anio: this.anio,
              mes: this.mesActual,
              red: this.red,
              microred: this.microred,
              establecimiento: this.establecimiento,
              curso: this.cursoVida
          }
      }).then(response => {
            this.medicamentos = response.data
      })
      this.overlay = false
    },
    abrirAlerta(){
      this.dialogAlerta = true
    },
    isMobile() {
      if( screen.width <= 760 ) {
          return true;
      }
      else {
          return false;
      }
    },
    updateAnio(){
      this.getMeses()
      this.getIndicador()
      this.getRadar()
      this.getAlertas()
      this.getMorbilidades()
      this.getMedicamentos()
    },
    updateRed(){
      this.microred = []
      this.getMicroRedes()
      this.establecimiento = []
      this.getEstablecimientos()
      this.getIndicador()
      this.getRadar()
      this.getAlertas()
      this.getMorbilidades()
      this.getMedicamentos()
    },
    updateMicroRed(){
      this.establecimiento = []
      this.getEstablecimientos();
      this.getIndicador()
      this.getRadar()
      this.getAlertas()
      this.getMorbilidades()
      this.getMedicamentos()
    },
    updateEstablecimiento(){
      this.getIndicador()
      this.getRadar()
      this.getAlertas()
      this.getMorbilidades()
      this.getMedicamentos()
    },
    updateMeses(){
      this.getIndicador()
      this.getRadar()
      if(this.mes.length == 1){
        this.mesActual = this.mes[0]
      }
      if(this.mes.length > 1){
        this.mes.forEach(function(m) {
          if(this.mesActual < m){
            this.mesActual = m
          }
        }, this);
      }
      this.getAlertas()
      this.getMorbilidades()
      this.getMedicamentos()
      if(this.mes.length === 0){
        this.tituloAvanceGraficos = this.meses[this.mesActual1-1].Nombre
      }
      else{
        this.tituloAvanceGraficos = ''
      }
    },
    updateCursoVida(){
      this.$store.state.curso = this.cursoVida
      this.getIndicador()
      this.getRadar()
      this.getAlertas()
      this.getGraficoIndicador()
      this.getGrupoEtareo()
      this.getMorbilidades()
      this.getMedicamentos()
    },
    updateSubCursoVida(){
      this.$store.state.grupo = this.grupoEtareo
      this.getRadar()
      this.getMorbilidades()
      this.getIndicador()
      this.getAlertas()
    },
  }
};
</script>